import { render } from "./FormBeritaAcara.vue?vue&type=template&id=5146e1ec"
import script from "./FormBeritaAcara.vue?vue&type=script&lang=js"
export * from "./FormBeritaAcara.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__